import { PaginatedListState } from './pagination';

// Converts an object to a URL query string
export const serializeObjectToUrlParams = (
  obj: Record<string, unknown>,
  options: {
    keyPrefix?: string;
    transformKey?: (key: string) => string;
  } = {},
  initialSearchString = ''
): string => {
  const { keyPrefix, transformKey } = options;
  const searchParams = new URLSearchParams(initialSearchString);

  const getParamKey = (key: string): string => {
    // Apply custom key transformation if provided
    const transformedKey = transformKey ? transformKey(key) : key;
    // Apply prefix if provided
    return keyPrefix ? `${keyPrefix}.${transformedKey}` : transformedKey;
  };

  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) {
      searchParams.set(getParamKey(key), String(value));
    } else {
      searchParams.delete(getParamKey(key));
    }
  }

  return searchParams.toString();
};

// Combines category filter and search param into a single query parameter for the API
export const convertCategoryAndSearchToQueryParam = <FilterKey extends string>(
  state: PaginatedListState<FilterKey | 'category'>
): PaginatedListState => {
  return {
    ...state,
    params: {
      ...state.params,
      filters: { query: `${state.params.filters.category || ''} ${state.params.search}`.trim() },
      search: '',
    },
  } as PaginatedListState;
};
